/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Banner_BodyInputs */

const en_cookie_banner_body = /** @type {(inputs: Cookie_Banner_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use essential cookies to run the app, and analytics only with your permission.`)
};

const es_cookie_banner_body = /** @type {(inputs: Cookie_Banner_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos cookies esenciales para que la aplicación funcione, y analítica solo con tu permiso.`)
};

const fr_cookie_banner_body = /** @type {(inputs: Cookie_Banner_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous utilisons des cookies essentiels pour faire fonctionner l'application, et l'analytique uniquement avec votre accord.`)
};

/**
* | output |
* | --- |
* | "We use essential cookies to run the app, and analytics only with your permission." |
*
* @param {Cookie_Banner_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const cookie_banner_body = /** @type {((inputs?: Cookie_Banner_BodyInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Banner_BodyInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cookie_banner_body(inputs)
	if (locale === "es") return es_cookie_banner_body(inputs)
	return fr_cookie_banner_body(inputs)
});